import { render, staticRenderFns } from "./LanguageBottomDrawer.vue?vue&type=template&id=5d2a0464&"
import script from "./LanguageBottomDrawer.vue?vue&type=script&lang=js&"
export * from "./LanguageBottomDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports